import React from 'react';
import {
  NavLink as RRNavLink
} from "react-router-dom";

import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
 } from 'reactstrap';

import PropTypes from 'prop-types';
import { auth } from '../firebase';
import * as routes from '../Constants/routes';

const NavigationLinks = (props, { authUser, menuToggle }) =>
<React.Fragment>
    { authUser
        ? <NavigationAuth menuToggle={props.menuToggle} />
        : <NavigationNonAuth menuToggle={props.menuToggle} />
    }
</React.Fragment>

const navbarStyle={
    backgroundColor: "black",
    borderBottomStyle: "solid",
    borderColor: "darkslategray"
}

NavigationLinks.contextTypes = {
  authUser: PropTypes.object,
};

  const NavigationAuth = ({menuToggle}) =>

  <React.Fragment>
      <Nav navbar>
        <NavItem>
          <NavLink exact to="/" activeClassName="active" tag={RRNavLink} onClick={menuToggle}>Home</NavLink>
        </NavItem>

        <UncontrolledDropdown nav inNavbar>
           <DropdownToggle nav caret>
             Decks
           </DropdownToggle>
           <DropdownMenu left="true" style={navbarStyle}>
             <DropdownItem tag="a" style={navbarStyle}>
               <NavLink to="/Cards" activeClassName="active" tag={RRNavLink} onClick={menuToggle}>Card Gallery</NavLink>
             </DropdownItem >
             <DropdownItem tag="a" style={navbarStyle}>
               <NavLink to="/Decks" activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Deck Lists</NavLink>
             </DropdownItem>
             <DropdownItem tag="a" style={navbarStyle}>
               <NavLink to={routes.DECKBUILDERV2} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Deck Builder</NavLink>
             </DropdownItem>
           </DropdownMenu>
         </UncontrolledDropdown>

        <NavItem>
          <NavLink to="/ArticleCollection" activeClassName="active" tag={RRNavLink} onClick={menuToggle}>Articles</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to={routes.TOURNAMENTGRID} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Tournaments</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to={routes.LEADERBOARD} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Hall of Nova</NavLink>
        </NavItem>
         <NavItem >
          <NavLink to={routes.HOME}  activeClassName="active" tag={RRNavLink} onClick={menuToggle}>User Home</NavLink>
        </NavItem>
      </Nav>
      <Nav navbar className="ml-md-auto">

        <NavItem >
          <NavLink to={routes.LANDING}  activeClassName="active" tag={RRNavLink} onClick={auth.doSignOut}><i className='fas fa-sign-out-alt fa-2x'></i></NavLink>
        </NavItem>
      </Nav>
</React.Fragment>


  const NavigationNonAuth = ({menuToggle}) =>

  <React.Fragment>
      <Nav navbar>
        <NavItem>
          <NavLink exact to="/" activeClassName="active" tag={RRNavLink} onClick={menuToggle}>Home</NavLink>
        </NavItem>

        <UncontrolledDropdown nav inNavbar >
           <DropdownToggle nav caret >
             Decks
           </DropdownToggle>
           <DropdownMenu left="true" style={navbarStyle}>
             <DropdownItem tag="a" style={navbarStyle}>
               <NavLink to="/Cards" activeClassName="active" tag={RRNavLink} onClick={menuToggle}>Card Gallery</NavLink>
             </DropdownItem>
             <DropdownItem tag="a" style={navbarStyle}>
               <NavLink to="/Decks" activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Deck Lists</NavLink>
             </DropdownItem>
             <DropdownItem tag="a" style={navbarStyle}>
               <NavLink to={routes.DECKBUILDERV2} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Deck Builder</NavLink>
             </DropdownItem>
           </DropdownMenu>
         </UncontrolledDropdown>

        <NavItem>
          <NavLink to="/ArticleCollection" activeClassName="active" tag={RRNavLink} onClick={menuToggle}>Articles</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to={routes.TOURNAMENTGRID} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Tournaments</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to={routes.LEADERBOARD} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Hall of Nova</NavLink>
        </NavItem>
        </Nav>
      <Nav navbar className="ml-md-auto">
        <NavItem >
          <NavLink to={routes.LOGIN}  activeClassName="active" tag={RRNavLink} onClick={menuToggle}><i className='fas fa-sign-in-alt fa-2x'></i></NavLink>
        </NavItem>
      </Nav>
  </React.Fragment>




export default NavigationLinks;


/*
<NavItem>
  <NavLink to="/DeckBuilder" activeClassName="active" tag={RRNavLink} >Deck Builder</NavLink>
</NavItem>

<NavItem>
  <NavLink to={routes.TOURNAMENTGRID} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Tournaments</NavLink>
</NavItem>

<NavItem>
  <NavLink to={routes.TOURNAMENTGRID} activeClassName="active" tag={RRNavLink} onClick={menuToggle} >Tournaments</NavLink>
</NavItem>
*/



// WEBPACK FOOTER //
// ./src/Constants/Navigation.js